import React, { useEffect, useState } from "react";
import { useAuthContext } from "../context/auth";
import api from "../lib/api";
import { ClubDayBadgesDetailData } from "../Api";

function useClub() {
  const { classId, step } = useAuthContext();
  const [clubDayBadges, setClubDayBadges] = useState<
    ClubDayBadgesDetailData["classAchievements"]
  >([]);
  useEffect(() => {
    const getClubdays = async () => {
      if (classId) {
        api.fits.clubDayBadgesDetail(classId).then((res) => {
          setClubDayBadges(res.data.classAchievements);
        });
      }
    };
    getClubdays();
  }, [step, classId]);

  return clubDayBadges;
}

export default useClub;
